import { apiRequest } from './http';
import type { Meta } from './types';

// §5.1 GET /api/meta — 부트스트랩.
export function fetchMeta(signal?: AbortSignal): Promise<Meta> {
  return apiRequest<Meta>('/meta', { signal });
}
